import { api } from "../utils/api";

const SystemNotificationService = {
  get: async () => {
    try {
      const response = await api.get(`/api/notifications`, {});
      const notifications = response.data;
      return notifications;
    } catch (error) {
      return false;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/api/notifications/${id}`, {});
      const notifications = response.data;
      return notifications;
    } catch (error) {
      return false;
    }
  },
};

export default SystemNotificationService;
